import React, { ReactNode } from "react";
import './TabBar.scss';

class TabBar extends React.Component {
	public constructor(props: any) {
		super(props);
	}

	public render(): ReactNode {
		return (
			<div className="tab-bar">
				<div className="tab-bar-items-wrapper">
					{this.props.children}
				</div>
			</div>
		);
	}
}

export default TabBar;